/**
 * Token Health Service
 * Provides functions to check Zerodha token status
 */

import { getApiUrl } from "../config/api.config";

/**
 * Fetch the current Zerodha token health status
 * @returns {Promise<Object>} Token health data
 */
export const fetchTokenHealth = async () => {
  const response = await fetch(getApiUrl("/auth/token-health"), {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Failed to fetch token health");
  }

  const data = await response.json();
  return data.data;
};

/**
 * Format the token creation time for display
 * @param {string} createdAt - ISO timestamp
 * @returns {string} Formatted time string
 */
export const formatTokenTime = (createdAt) => {
  if (!createdAt) return "Unknown";
  const date = new Date(createdAt);
  return date.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
